export default __webpack_public_path__ + "static/media/Commission-small.118606e2.jpeg";